import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import { FeatherFileText, FeatherImage } from '@subframe/core';
import type { DocumentoCorreiosCertificado } from '../../../types/certificadoAcessosTypes';
interface DocumentoCorreiosConteudoProps {
  documento: DocumentoCorreiosCertificado;
  destinatarioNome: string;
}
function DocumentoCorreiosConteudo(t0) {
  const $ = _c(18);
  const {
    documento,
    destinatarioNome
  } = t0;
  let t1;
  if ($[0] !== destinatarioNome || $[1] !== documento.titulo) {
    t1 = <span className="border-brand-600 text-brand-600 mb-[14px] inline-block rounded-[5px] border border-solid px-3 py-[5px] text-[12px] font-semibold">{documento.titulo} — {destinatarioNome}</span>;
    $[0] = destinatarioNome;
    $[1] = documento.titulo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `mx-auto flex w-full max-w-[430px] flex-col items-center justify-center gap-3 rounded-[6px] border px-8 text-center ${documento.disponivel ? "h-[300px] border-solid border-neutral-200 bg-neutral-50" : "border-warning-300 bg-warning-50 h-[140px] border-dashed"}`;
  let t3;
  if ($[3] !== documento.disponivel || $[4] !== documento.imagemUrl || $[5] !== documento.titulo) {
    t3 = documento.disponivel && documento.imagemUrl ? <Image src={documento.imagemUrl} alt={documento.titulo} width={380} height={260} className="h-full w-full object-contain" /> : documento.disponivel ? <FeatherImage className="h-8 w-8 text-neutral-400" /> : <FeatherFileText className="text-warning-700 h-8 w-8" />;
    $[3] = documento.disponivel;
    $[4] = documento.imagemUrl;
    $[5] = documento.titulo;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== documento.descricao || $[8] !== documento.disponivel || $[9] !== documento.imagemUrl) {
    t4 = !(documento.disponivel && documento.imagemUrl) && <span className={`text-[13px] ${documento.disponivel ? "text-neutral-500" : "text-warning-800"}`}>{documento.descricao}</span>;
    $[7] = documento.descricao;
    $[8] = documento.disponivel;
    $[9] = documento.imagemUrl;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4) {
    t5 = <div className="rounded-[12px] border border-solid border-neutral-900/20 p-4"><div className={t2}>{t3}{t4}</div></div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== t1 || $[16] !== t5) {
    t6 = <>{t1}{t5}</>;
    $[15] = t1;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
}
export function DocumentoCorreiosBloco(t0) {
  const $ = _c(3);
  const {
    documento,
    destinatarioNome
  } = t0;
  let t1;
  if ($[0] !== destinatarioNome || $[1] !== documento) {
    t1 = <div className="px-[37px] pb-6"><DocumentoCorreiosConteudo documento={documento} destinatarioNome={destinatarioNome} /></div>;
    $[0] = destinatarioNome;
    $[1] = documento;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}